import Axios from '@/api/http'

/**
 * 新增应用联系人控件选择记录
 * */
export function addapprovaluserchose(date) {
  return Axios({
    method: 'post',
    url: '/openapi/addapprovaluserchose',
    data: date
  })
}

/**
 * 获取最近使用的用户列表
 * */
export function getapprovaluserchoselist(date) {
  return Axios({
    method: 'post',
    url: '/openapi/getapprovaluserchoselist',
    data: date
  })
}

/**
 * 删除应用联系人控件最近选择记录
 * */
export function deleteapprovaluserchose(date) {
  return Axios({
    method: 'post',
    url: '/openapi/deleteapprovaluserchose',
    data: date
  })
}

/**
 * 新增自定义分组
 * */
export function adduserfolder(date) {
  return Axios({
    method: 'post',
    url: '/openapi/adduserfolder',
    data: date
  })
}

/**
 * 修改自定义分组
 * */
export function updateuserfolder(date) {
  return Axios({
    method: 'post',
    url: '/openapi/updateuserfolder',
    data: date
  })
}

/**
 * 删除自定义分组
 * */
export function deleteuserfolder(date) {
  return Axios({
    method: 'post',
    url: '/openapi/deleteuserfolder',
    data: date
  })
}

/**
 * 获取自定义分组列表
 * */
export function getuserfolderlist(date) {
  return Axios({
    method: 'post',
    url: '/openapi/getuserfolderlist',
    data: date
  })
}

/**
 * 根据分组获取分组下方用户
 * */
export function getuserlistbyfolder(date) {
  return Axios({
    method: 'post',
    url: '/openapi/getuserlistbyfolder',
    data: date
  })
}

/**
 * 拖拉排序
 * */
export function batchupdateuserfolderorders(date) {
  return Axios({
    method: 'post',
    url: '/openapi/batchupdateuserfolderorders',
    data: date
  })
}